import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  collectionArgsConfig,
} from '../../utils/event_constants';

export const triggerCustomFunction = [
  {
    name: 'triggerCustomFunction',
    label: 'Trigger Function',
    args: [
      {
        name: 'FunctionName',
        label: 'Function Name',
        type: 'dropdown',
        optionsType: 'getCustomFunctionFromApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      collectionArgsConfig,
      {
        name: 'referenceField',
        label: 'Reference Field',
        type: 'dropdown',
        optionsType: 'fieldApi',
        options: [],
        value: '',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
      // Send Browser Storage Location Payload
      {
        name: 'bslPayload',
        label: 'Send Browser Storage Data',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: ['SESSION_STORAGE'],
      },
      // Store formData and responseData in browser storage
      ...browserStorageArgsConfig,
    ],
  },
];
